import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { filter, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolName } from '../../../../../../cross-team-shared/tools-names';
import { TaskWorkspaceStore } from '../../../../../h3ml/state/task-workspace-store';
import { getSelectedToolStore } from '../../../../../h3ml/state/task-workspace-store-utils';

@Component({
  selector: 'h3-point-cloud-secondary-toolbar',
  templateUrl: './point-cloud-secondary-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PointCloudSecondaryToolbarComponent {
  selectedTool$: Observable<ToolName>;

  constructor(taskWorkspaceStore: TaskWorkspaceStore) {
    const { selectedOutputName } = taskWorkspaceStore.state();
    this.selectedTool$ = getSelectedToolStore(
      taskWorkspaceStore,
      selectedOutputName,
    ).$.pipe(
      filter(isDefined),
      map((selectedTool) => selectedTool.name),
    );
  }
}
